var anchorPointUtilities = {
  options: undefined,
  currentCtxEdge: undefined,
  currentCtxPos: undefined,
  currentAnchorIndex: undefined,
  ignoredClasses: undefined,
  setIgnoredClasses: function(_ignoredClasses) {
    this.ignoredClasses = _ignoredClasses;
  },
  syntax: {
    bend: {
      edge: 'segments',
      class: 'edgebendediting-hasbendpoints',
      multiClass: 'edgebendediting-hasmultiplebendpoints',
      weight: 'cyedgebendeditingWeights',
      distance: 'cyedgebendeditingDistances',
      weightCss: 'segment-weights',
      distanceCss: 'segment-distances'
    },
    control: {
      edge: 'unbundled-bezier',
      class: 'edgecontrolediting-hascontrolpoints',
      multiClass: 'edgecontrolediting-hasmultiplecontrolpoints',
      weight: 'cyedgecontroleditingWeights',
      distance: 'cyedgecontroleditingDistances',
      weightCss: 'control-point-weights',
      distanceCss: 'control-point-distances'
    }
  },
  // gets edge type as 'bend' or 'control'
  // the interchanging if-s are necessary to set the priority of the tags
  // example: an edge with type segment and a class 'hascontrolpoints' will be classified as unbundled bezier
  getEdgeType: function(edge) {
    if (!edge || edge.data() === undefined)
      return 'none';
    else if (edge.hasClass(this.syntax['bend']['class']))
      return 'bend';
    else if (edge.hasClass(this.syntax['control']['class']))
      return 'control';
    else if (edge.css('curve-style').includes(this.syntax['bend']['edge']))
      return 'bend';
    else if (edge.css('curve-style') === this.syntax['control']['edge'])
      return 'control';
    else if (this.options.bendPositionsFunction(edge) &&
      this.options.bendPositionsFunction(edge).length > 0)
      return 'bend';
    else if (this.options.controlPositionsFunction(edge) &&
      this.options.controlPositionsFunction(edge).length > 0)
      return 'control';
    return 'none';
  },
  // initilize anchor points based on bendPositionsFcn and controlPositionFcn
  initAnchorPoints: function(bendPositionsFcn, controlPositionsFcn, edges, forceType) {
    for (var i = 0; i < edges.length; i++) {
      var edge = edges[i];
      var type = forceType || this.getEdgeType(edge);
      if (type === 'none') {
        continue;
      }
      if (!this.isIgnoredEdge(edge)) {

        var anchorPositions;

        // get the anchor positions by applying the functions for this edge
        if (type === 'bend')
          anchorPositions = bendPositionsFcn.apply(this, edge);
        else if (type === 'control')
          anchorPositions = controlPositionsFcn.apply(this, edge);

        var result = {
          weights: [],
          distances: []
        };
        if (anchorPositions) {
          result = this.convertToRelativePositions(edge, anchorPositions);
        } else {
          var weights = edge.data(this.syntax[type]['weight']);
          var distances = edge.data(this.syntax[type]['distance']);
          if (weights && distances) {
            result = {
              weights: weights,
              distances: distances
            };
          }
        }

        // if there are anchors set weights and distances accordingly and add class to enable style changes
        if (result.distances.length > 0) {
          edge.data(this.syntax[type]['weight'], result.weights);
          edge.data(this.syntax[type]['distance'], result.distances);
          edge.addClass(this.syntax[type]['class']);
          if (result.distances.length > 1) {
            edge.addClass(this.syntax[type]['multiClass']);
          }
        } else {
          edge.data(this.syntax[type]['weight'], []);
          edge.data(this.syntax[type]['distance'], []);
          if (edge.hasClass(this.syntax[type]['class']))
            edge.removeClass(this.syntax[type]['class']);
          if (edge.hasClass(this.syntax[type]['multiClass']))
            edge.removeClass(this.syntax[type]['multiClass']);
        }
      }
    }
  },

  isIgnoredEdge: function(edge) {
    // Check if source and target nodes are visible
    var sourceNode = edge.source();
    var targetNode = edge.target();
    if (!sourceNode || !targetNode || sourceNode.length === 0 || targetNode.length === 0 ||
      !sourceNode.visible() || !targetNode.visible()) {
      return true; // Ignore edges with hidden source/target
    }

    var startX = sourceNode.position('x');
    var startY = sourceNode.position('y');
    var endX = targetNode.position('x');
    var endY = targetNode.position('y');

    if ((startX == endX && startY == endY) || (sourceNode.id() == targetNode.id())) {
      return true;
    }
    for (var i = 0; this.ignoredClasses && i < this.ignoredClasses.length; i++) {
      if (edge.hasClass(this.ignoredClasses[i])) {
        return true;
      }
    }
    return false;
  },
  //Get the direction of the line from source point to the target point
  getLineDirection: function(srcPoint, tgtPoint) {
    if (srcPoint.y == tgtPoint.y && srcPoint.x < tgtPoint.x) {
      return 1;
    }
    if (srcPoint.y < tgtPoint.y && srcPoint.x < tgtPoint.x) {
      return 2;
    }
    if (srcPoint.y < tgtPoint.y && srcPoint.x == tgtPoint.x) {
      return 3;
    }
    if (srcPoint.y < tgtPoint.y && srcPoint.x > tgtPoint.x) {
      return 4;
    }
    if (srcPoint.y == tgtPoint.y && srcPoint.x > tgtPoint.x) {
      return 5;
    }
    if (srcPoint.y > tgtPoint.y && srcPoint.x > tgtPoint.x) {
      return 6;
    }
    if (srcPoint.y > tgtPoint.y && srcPoint.x == tgtPoint.x) {
      return 7;
    }
    return 8;//if srcPoint.y > tgtPoint.y and srcPoint.x < tgtPoint.x
  },
  getSrcTgtPointsAndTangents: function(edge) {
    var sourceNode = edge.source();
    var targetNode = edge.target();

    var tgtPosition = targetNode.position();
    var srcPosition = sourceNode.position();

    var srcPoint = sourceNode.position();
    var tgtPoint = targetNode.position();


    var m1 = (tgtPoint.y - srcPoint.y) / (tgtPoint.x - srcPoint.x);
    var m2 = -1 / m1;

    // Coincident endpoints give 0/0. Vertical (Infinity) and horizontal (0)
    // are handled downstream; NaN is not, and propagates into the weights and
    // distances written to segment-weights/segment-distances.
    var degenerate = !isFinite(m1) && !(m1 === Infinity || m1 === -Infinity);

    return {
      m1: m1,
      m2: m2,
      degenerate: degenerate,
      srcPoint: srcPoint,
      tgtPoint: tgtPoint
    };
  },
  getIntersection: function(edge, point, srcTgtPointsAndTangents) {
    if (srcTgtPointsAndTangents === undefined) {
      srcTgtPointsAndTangents = this.getSrcTgtPointsAndTangents(edge);
    }

    var srcPoint = srcTgtPointsAndTangents.srcPoint;
    var tgtPoint = srcTgtPointsAndTangents.tgtPoint;
    var m1 = srcTgtPointsAndTangents.m1;
    var m2 = srcTgtPointsAndTangents.m2;

    var intersectX;
    var intersectY;

    if (m1 == Infinity || m1 == -Infinity) {
      intersectX = srcPoint.x;
      intersectY = point.y;
    } else if (m1 == 0) {
      intersectX = point.x;
      intersectY = srcPoint.y;
    } else {
      var a1 = srcPoint.y - m1 * srcPoint.x;
      var a2 = point.y - m2 * point.x;

      intersectX = (a2 - a1) / (m1 - m2);
      intersectY = m1 * intersectX + a1;
    }

    //Intersection point is the intersection of the lines passing through the nodes and
    //passing through the bend or control point and perpendicular to the other line
    var intersectionPoint = {
      x: intersectX,
      y: intersectY
    };

    return intersectionPoint;
  },
  getAnchorsAsArray: function(edge) {
    var type = this.getEdgeType(edge);

    if (type === 'none') {
      return undefined;
    }

    if (!edge.css('curve-style').includes(this.syntax[type]['edge'])) {
      return undefined;
    }

    // Check if source and target nodes are visible (not inside collapsed parent)
    var sourceNode = edge.source();
    var targetNode = edge.target();
    if (!sourceNode || !targetNode || sourceNode.length === 0 || targetNode.length === 0 ||
      !sourceNode.visible() || !targetNode.visible()) {
      return undefined;
    }

    var anchorList = [];
    var getDistances = function(edge, syntax) {
      var distanceFromStyle = edge.pstyle(syntax[type]['distanceCss']);
      if (distanceFromStyle) {
        return distanceFromStyle.pfValue;
      }
      if (!distanceFromStyle && edge.data('cyedgecontroleditingDistances')) {
        return edge.data('cyedgecontroleditingDistances');
      }
      return [];
    };
    var weights = edge.pstyle(this.syntax[type]['weightCss']) ?
      edge.pstyle(this.syntax[type]['weightCss']).pfValue : [];
    var distances = getDistances(edge, this.syntax);
    var minLengths = Math.min(weights.length, distances.length);
    var srcPos = edge.source().position();
    var tgtPos = edge.target().position();

    var dy = (tgtPos.y - srcPos.y);
    var dx = (tgtPos.x - srcPos.x);

    var l = Math.sqrt(dx * dx + dy * dy);

    var vector = {
      x: dx,
      y: dy
    };

    var vectorNorm = {
      x: vector.x / l,
      y: vector.y / l
    };

    var vectorNormInverse = {
      x: -vectorNorm.y,
      y: vectorNorm.x
    };

    for (var s = 0; s < minLengths; s++) {
      var w = weights[s];
      var d = distances[s];

      var w1 = (1 - w);
      var w2 = w;

      var posPts = {
        x1: srcPos.x,
        x2: tgtPos.x,
        y1: srcPos.y,
        y2: tgtPos.y
      };

      var midptPts = posPts;

      var adjustedMidpt = {
        x: midptPts.x1 * w1 + midptPts.x2 * w2,
        y: midptPts.y1 * w1 + midptPts.y2 * w2
      };
      anchorList.push(
        adjustedMidpt.x + vectorNormInverse.x * d,
        adjustedMidpt.y + vectorNormInverse.y * d
      );
    }

    return anchorList;
  },
  convertToRelativePosition: function(edge, point, srcTgtPointsAndTangents) {
    if (srcTgtPointsAndTangents === undefined) {
      srcTgtPointsAndTangents = this.getSrcTgtPointsAndTangents(edge);
    }

    if (srcTgtPointsAndTangents.degenerate) {
      return { weight: 0, distance: 0 };
    }

    var intersectionPoint = this.getIntersection(edge, point, srcTgtPointsAndTangents);
    var intersectX = intersectionPoint.x;
    var intersectY = intersectionPoint.y;

    var srcPoint = srcTgtPointsAndTangents.srcPoint;
    var tgtPoint = srcTgtPointsAndTangents.tgtPoint;

    var weight;

    if (intersectX != srcPoint.x) {
      weight = (intersectX - srcPoint.x) / (tgtPoint.x - srcPoint.x);
    } else if (intersectY != srcPoint.y) {
      weight = (intersectY - srcPoint.y) / (tgtPoint.y - srcPoint.y);
    } else {
      weight = 0;
    }

    var distance = Math.sqrt(Math.pow((intersectY - point.y), 2)
      + Math.pow((intersectX - point.x), 2));

    //Get the direction of the line form source point to target point
    var direction1 = this.getLineDirection(srcPoint, tgtPoint);
    //Get the direction of the line from intesection point to the point
    var direction2 = this.getLineDirection(intersectionPoint, point);

    //If the difference is not -2 and not 6 then the direction of the distance is negative
    if (direction1 - direction2 != -2 && direction1 - direction2 != 6) {
      if (distance != 0)
        distance = -1 * distance;
    }

    return {
      weight: weight,
      distance: distance
    };
  },
  convertToRelativePositions: function(edge, anchorPoints) {
    var srcTgtPointsAndTangents = this.getSrcTgtPointsAndTangents(edge);

    var weights = [];
    var distances = [];

    for (var i = 0; anchorPoints && i < anchorPoints.length; i++) {
      var anchor = anchorPoints[i];
      var relativeAnchorPosition = this.convertToRelativePosition(edge, anchor, srcTgtPointsAndTangents);

      weights.push(relativeAnchorPosition.weight);
      distances.push(relativeAnchorPosition.distance);
    }

    return {
      weights: weights,
      distances: distances
    };
  },
  addAnchorPoint: function(edge, newAnchorPoint, type = undefined) {
    if (edge === undefined || newAnchorPoint === undefined) {
      edge = this.currentCtxEdge;
      newAnchorPoint = this.currentCtxPos;
    }

    if (type === undefined)
      type = this.getEdgeType(edge);

    var weightStr = this.syntax[type]['weight'];
    var distanceStr = this.syntax[type]['distance'];

    var relativePosition = this.convertToRelativePosition(edge, newAnchorPoint);
    var originalAnchorWeight = relativePosition.weight;

    var startX = edge.source().position('x');
    var startY = edge.source().position('y');
    var endX = edge.target().position('x');
    var endY = edge.target().position('y');
    var startWeight = this.convertToRelativePosition(edge, { x: startX, y: startY }).weight;
    var endWeight = this.convertToRelativePosition(edge, { x: endX, y: endY }).weight;
    var weightsWithTgtSrc = [startWeight].concat(edge.data(weightStr) ? edge.data(weightStr) : []).concat([endWeight]);

    var anchorsList = this.getAnchorsAsArray(edge);

    var minDist = Infinity;
    var intersection;
    var ptsWithTgtSrc = [startX, startY]
      .concat(anchorsList ? anchorsList : [])
      .concat([endX, endY]);
    var newAnchorIndex = -1;

    for (var i = 0; i < weightsWithTgtSrc.length - 1; i++) {
      var w1 = weightsWithTgtSrc[i];
      var w2 = weightsWithTgtSrc[i + 1];

      //check if the weight is between w1 and w2
      const b1 = this.compareWithPrecision(originalAnchorWeight, w1, true);
      const b2 = this.compareWithPrecision(originalAnchorWeight, w2);
      const b3 = this.compareWithPrecision(originalAnchorWeight, w2, true);
      const b4 = this.compareWithPrecision(originalAnchorWeight, w1);
      if ((b1 && b2) || (b3 && b4)) {
        var startX = ptsWithTgtSrc[2 * i];
        var startY = ptsWithTgtSrc[2 * i + 1];
        var endX = ptsWithTgtSrc[2 * i + 2];
        var endY = ptsWithTgtSrc[2 * i + 3];

        var start = {
          x: startX,
          y: startY
        };

        var end = {
          x: endX,
          y: endY
        };

        var m1 = (startY - endY) / (startX - endX);
        var m2 = -1 / m1;

        var srcTgtPointsAndTangents = {
          srcPoint: start,
          tgtPoint: end,
          m1: m1,
          m2: m2
        };

        var currentIntersection = this.getIntersection(edge, newAnchorPoint, srcTgtPointsAndTangents);
        var dist = Math.sqrt(Math.pow((newAnchorPoint.x - currentIntersection.x), 2)
          + Math.pow((newAnchorPoint.y - currentIntersection.y), 2));

        //Update the minimum distance
        if (dist < minDist) {
          minDist = dist;
          intersection = currentIntersection;
          newAnchorIndex = i;
        }
      }
    }

    if (intersection !== undefined) {
      newAnchorPoint = intersection;
    }

    relativePosition = this.convertToRelativePosition(edge, newAnchorPoint);

    if (intersection === undefined) {
      relativePosition.distance = 0;
    }

    var weights = edge.data(weightStr);
    var distances = edge.data(distanceStr);

    weights = weights ? weights : [];
    distances = distances ? distances : [];

    if (weights.length === 0) {
      newAnchorIndex = 0;
    }

//    weights.push(relativeBendPosition.weight);
//    distances.push(relativeBendPosition.distance);
    if (newAnchorIndex != -1) {
      weights.splice(newAnchorIndex, 0, relativePosition.weight);
      distances.splice(newAnchorIndex, 0, relativePosition.distance);
    }

    edge.data(weightStr, weights);
    edge.data(distanceStr, distances);

    edge.addClass(this.syntax[type]['class']);
    if (weights.length > 1 || distances.length > 1) {
      edge.addClass(this.syntax[type]['multiClass']);
    }
    const cy = edge?.cy();
    if (cy) {
      cy.emit('controlPointAdded', edge, newAnchorIndex);
    }
    return newAnchorIndex;
  },
  updateAnchorPoint: function(edge, anchorIndex, newAnchorPoint) {
    if (!edge || anchorIndex === undefined || !newAnchorPoint) {
      console.error('Edge, anchorIndex, and newAnchorPoint must be provided');
      return;
    }

    var type = this.getEdgeType(edge);
    if (this.edgeTypeNoneShouldntHappen(type, 'updateAnchorPoint')) {
      return;
    }

    var weightStr = this.syntax[type]['weight'];
    var distanceStr = this.syntax[type]['distance'];

    // Retrieve current weights and distances
    var weights = edge.data(weightStr) || [];
    var distances = edge.data(distanceStr) || [];

    if (anchorIndex < 0 || anchorIndex >= weights.length) {
      console.error('Anchor index is out of bounds');
      return;
    }

    // Calculate the new relative position for the updated anchor point
    var relativePosition = this.convertToRelativePosition(edge, newAnchorPoint);

    // Update the anchor point's weight and distance
    weights[anchorIndex] = relativePosition.weight;
    distances[anchorIndex] = relativePosition.distance;

    // Update the edge data with the modified weights and distances
    edge.data(weightStr, weights);
    edge.data(distanceStr, distances);

    // Emit an event to notify that the anchor point has been updated
    const cy = edge?.cy();
    if (cy) {
      cy.emit('controlPointUpdated', edge, { anchorIndex, newAnchorPoint });
    }
  },
  updateAnchorPointsBatch: function(edge, newAnchorPoints, type = undefined) {
    if (!edge || !Array.isArray(newAnchorPoints)) {
      console.error('Edge and an array of new anchor points must be provided');
      return;
    }

    if (type === undefined) {
      type = this.getEdgeType(edge);
    }

    if (this.edgeTypeNoneShouldntHappen(type, 'updateAnchorPointsBatch')) {
      return;
    }

    const weightStr = this.syntax[type]['weight'];
    const distanceStr = this.syntax[type]['distance'];

    // Retrieve current weights and distances
    let weights = edge.data(weightStr) || [];
    let distances = edge.data(distanceStr) || [];

    // Validate the input array length matches the existing anchor count
    if (newAnchorPoints.length !== weights.length) {
      console.error('Mismatch between the number of new anchor points and existing anchor points');
      return;
    }

    const srcTgtPointsAndTangents = this.getSrcTgtPointsAndTangents(edge);

    for (let i = 0; i < newAnchorPoints.length; i++) {
      const newPoint = newAnchorPoints[i];

      // Check if the anchor point at this index has been modified manually
      // This can be determined based on application-specific logic.
      const manualModificationFlag = edge.data(`manualAnchorModified_${i}`);
      if (manualModificationFlag) {
        continue;
      }

      // Update weights and distances for this anchor point
      const relativePosition = this.convertToRelativePosition(edge, newPoint, srcTgtPointsAndTangents);
      weights[i] = relativePosition.weight;
      distances[i] = relativePosition.distance;
    }

    // Save updated weights and distances back to the edge
    edge.data(weightStr, weights);
    edge.data(distanceStr, distances);

    // Adjust classes based on the number of anchor points
    if (weights.length > 1 || distances.length > 1) {
      edge.addClass(this.syntax[type]['multiClass']);
    } else {
      edge.removeClass(this.syntax[type]['multiClass']);
    }

    // Emit an event for batch update
    const cy = edge?.cy();
    if (cy) {
      cy.emit('controlPointsBatchUpdated', edge);
    }
  },
  removeAnchor: function(edge, anchorIndex) {
    if (edge === undefined || anchorIndex === undefined) {
      edge = this.currentCtxEdge;
      anchorIndex = this.currentAnchorIndex;
    }

    var type = this.getEdgeType(edge);

    if (this.edgeTypeNoneShouldntHappen(type, 'anchorPointUtilities.js, removeAnchor')) {
      return;
    }

    var distanceStr = this.syntax[type]['weight'];
    var weightStr = this.syntax[type]['distance'];

    var distances = edge.data(distanceStr);
    var weights = edge.data(weightStr);
    var positions;
    if (type === 'bend') {
      positions = this.options.bendPositionsFunction(edge);
    } else if (type === 'control') {
      positions = this.options.controlPositionsFunction(edge);
    }

    distances.splice(anchorIndex, 1);
    weights.splice(anchorIndex, 1);
    // position data is not given in demo so it throws error here
    // but it should be from the beginning
    if (positions)
      positions.splice(anchorIndex, 1);

    // only one anchor point left on edge
    if (distances.length == 1 || weights.length == 1) {
      edge.removeClass(this.syntax[type]['multiClass']);
    }
    // no more anchor points on edge
    else if (distances.length == 0 || weights.length == 0) {
      edge.removeClass(this.syntax[type]['class']);
      edge.data(distanceStr, []);
      edge.data(weightStr, []);
    } else {
      edge.data(distanceStr, distances);
      edge.data(weightStr, weights);
    }
  },
  removeAllAnchors: function(edge) {
    if (edge === undefined) {
      edge = this.currentCtxEdge;
    }
    var type = this.getEdgeType(edge);

    if (this.edgeTypeNoneShouldntHappen(type, 'anchorPointUtilities.js, removeAllAnchors')) {
      return;
    }

    // Remove classes from edge
    edge.removeClass(this.syntax[type]['class']);
    edge.removeClass(this.syntax[type]['multiClass']);

    // Remove all anchor point data from edge
    var distanceStr = this.syntax[type]['weight'];
    var weightStr = this.syntax[type]['distance'];
    edge.data(distanceStr, []);
    edge.data(weightStr, []);
    // position data is not given in demo so it throws error here
    // but it should be from the beginning
    if (type === 'bend' && this.options.bendPositionsFunction(edge)) {
      this.options.bendPointPositionsSetterFunction(edge, []);
    } else if (type === 'control' && this.options.controlPositionsFunction(edge)) {
      this.options.controlPointPositionsSetterFunction(edge, []);
    }
  },
  calculateDistance: function(pt1, pt2) {
    var diffX = pt1.x - pt2.x;
    var diffY = pt1.y - pt2.y;

    var dist = Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2));
    return dist;
  },
  /** (Less than or equal to) and (greater then equal to) comparisons with floating point numbers */
  compareWithPrecision: function(n1, n2, isLessThenOrEqual = false, precision = 0.01) {
    const diff = n1 - n2;
    if (Math.abs(diff) <= precision) {
      return true;
    }
    if (isLessThenOrEqual) {
      return n1 < n2;
    } else {
      return n1 > n2;
    }
  },
  edgeTypeNoneShouldntHappen: function(type, place) {
    if (type === 'none') {
      return true;
    }
    return false;
  }
};

module.exports = anchorPointUtilities;
